'use client';

import { useEffect, useRef } from 'react';
import { submissionSubmitted } from '@app/pdp/utils';

export default function BVSubmitReviewAnalytics() {
    const isConfigured = useRef(false);

    useEffect(() => {
        if (!IS_SSR && window.BV?.configure && !isConfigured.current) {
            window.BV.configure('global', {
                events: {
                    submissionSubmitted,
                },
            });

            isConfigured.current = true;
        }
    }, []);

    return null;
}
